function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BufferParameters = /*#__PURE__*/function () {
  function BufferParameters() {
    _classCallCheck(this, BufferParameters);
    BufferParameters.constructor_.apply(this, arguments);
  }
  return _createClass(BufferParameters, [{
    key: "getEndCapStyle",
    value: function getEndCapStyle() {
      return this._endCapStyle;
    }
  }, {
    key: "isSingleSided",
    value: function isSingleSided() {
      return this._isSingleSided;
    }
  }, {
    key: "setQuadrantSegments",
    value: function setQuadrantSegments(quadSegs) {
      this._quadrantSegments = quadSegs;
      if (this._quadrantSegments === 0) this._joinStyle = BufferParameters.JOIN_BEVEL;
      if (this._quadrantSegments < 0) {
        this._joinStyle = BufferParameters.JOIN_MITRE;
        this._mitreLimit = Math.abs(this._quadrantSegments);
      }
      if (quadSegs <= 0) {
        this._quadrantSegments = 1;
      }
      if (this._joinStyle !== BufferParameters.JOIN_ROUND) {
        this._quadrantSegments = BufferParameters.DEFAULT_QUADRANT_SEGMENTS;
      }
    }
  }, {
    key: "getJoinStyle",
    value: function getJoinStyle() {
      return this._joinStyle;
    }
  }, {
    key: "setJoinStyle",
    value: function setJoinStyle(joinStyle) {
      this._joinStyle = joinStyle;
    }
  }, {
    key: "setSimplifyFactor",
    value: function setSimplifyFactor(simplifyFactor) {
      this._simplifyFactor = simplifyFactor < 0 ? 0 : simplifyFactor;
    }
  }, {
    key: "getSimplifyFactor",
    value: function getSimplifyFactor() {
      return this._simplifyFactor;
    }
  }, {
    key: "getQuadrantSegments",
    value: function getQuadrantSegments() {
      return this._quadrantSegments;
    }
  }, {
    key: "setEndCapStyle",
    value: function setEndCapStyle(endCapStyle) {
      this._endCapStyle = endCapStyle;
    }
  }, {
    key: "getMitreLimit",
    value: function getMitreLimit() {
      return this._mitreLimit;
    }
  }, {
    key: "setMitreLimit",
    value: function setMitreLimit(mitreLimit) {
      this._mitreLimit = mitreLimit;
    }
  }, {
    key: "setSingleSided",
    value: function setSingleSided(isSingleSided) {
      this._isSingleSided = isSingleSided;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return BufferParameters;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "bufferDistanceError",
    value: function bufferDistanceError(quadSegs) {
      var alpha = Math.PI / 2.0 / quadSegs;
      return 1 - Math.cos(alpha / 2.0);
    }
  }]);
}();
export { BufferParameters as default };
BufferParameters.constructor_ = function () {
  this._quadrantSegments = BufferParameters.DEFAULT_QUADRANT_SEGMENTS;
  this._endCapStyle = BufferParameters.CAP_ROUND;
  this._joinStyle = BufferParameters.JOIN_ROUND;
  this._mitreLimit = BufferParameters.DEFAULT_MITRE_LIMIT;
  this._isSingleSided = false;
  this._simplifyFactor = BufferParameters.DEFAULT_SIMPLIFY_FACTOR;
  if (arguments.length === 0) {} else if (arguments.length === 1) {
    var quadrantSegments = arguments[0];
    this.setQuadrantSegments(quadrantSegments);
  } else if (arguments.length === 2) {
    var _quadrantSegments = arguments[0];
    var endCapStyle = arguments[1];
    this.setQuadrantSegments(_quadrantSegments);
    this.setEndCapStyle(endCapStyle);
  } else if (arguments.length === 4) {
    var _quadrantSegments2 = arguments[0];
    var _endCapStyle = arguments[1];
    var joinStyle = arguments[2];
    var mitreLimit = arguments[3];
    this.setQuadrantSegments(_quadrantSegments2);
    this.setEndCapStyle(_endCapStyle);
    this.setJoinStyle(joinStyle);
    this.setMitreLimit(mitreLimit);
  }
};
BufferParameters.CAP_ROUND = 1;
BufferParameters.CAP_FLAT = 2;
BufferParameters.CAP_SQUARE = 3;
BufferParameters.JOIN_ROUND = 1;
BufferParameters.JOIN_MITRE = 2;
BufferParameters.JOIN_BEVEL = 3;
BufferParameters.DEFAULT_QUADRANT_SEGMENTS = 8;
BufferParameters.DEFAULT_MITRE_LIMIT = 5.0;
BufferParameters.DEFAULT_SIMPLIFY_FACTOR = 0.01;